import React from "react";
import gmailIcon from "assets/icons/emailIcon.svg";
import { LuShare2 } from "react-icons/lu";
import { IoMdCopy } from "react-icons/io";

interface Props {
  onCopy: () => void;
  onGmailShare: () => void;
  className: string;
}

export const MobileViewBtns = ({ onCopy, onGmailShare, className }: Props) => {
  return (
    <div className={`${className} flex w-full border-t rounded-b-lg overflow-hidden text-xs justify-evenly py-4`}>
      <button onClick={onCopy} className="flex items-center justify-center text-xs cursor-pointer ">
        <IoMdCopy className="w-4 h-4" />
        <span>Copy Mail Content</span>
      </button>

      <div className="border-r border-gray-300 -my-4"></div>
      <button onClick={onGmailShare} className="flex items-center gap-2 justify-center text-xs cursor-pointer ">
        <LuShare2 className="w-4 h-4" />
        <span>Share via </span>
        <img src={gmailIcon} alt="Gmail" className="w-4 h-4" />
        <span>Gmail</span>
      </button>
    </div>
  );
};
